import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import MobileGate from './components/MobileGate';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 is handled by the axios refresh interceptor; retrying here
      // would just multiply requests that are going to fail the same way.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* BASE_URL comes from vite's `base`, so the router works both at the
          root and under a sub-path when embedded behind a proxy. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <MobileGate>
          <App />
        </MobileGate>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
